import Nav from "../../components/Nav"
import Footer from "../../components/Footer"
import TeamCards from "../../components/TeamCards"


const Team = () => {
  return(
    <>
      <Nav />
      <TeamCards />
      <Footer />
    </>
  )
}

export default Team